var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00065 15.1663C4.04732 15.1663 0.833984 11.953 0.833984 7.99967C0.833984 6.42634 1.33398 4.93301 2.28065 3.67967C2.44732 3.45967 2.76065 3.41967 2.98065 3.58634C3.20065 3.75301 3.24732 4.06634 3.08065 4.28634C2.26732 5.35967 1.83398 6.64634 1.83398 7.99967C1.83398 11.3997 4.60065 14.1663 8.00065 14.1663C11.4007 14.1663 14.1673 11.3997 14.1673 7.99967C14.1673 4.59967 11.4007 1.83301 8.00065 1.83301C7.72732 1.83301 7.50065 1.60634 7.50065 1.33301C7.50065 1.05967 7.72732 0.833008 8.00065 0.833008C11.954 0.833008 15.1673 4.04634 15.1673 7.99967C15.1673 11.953 11.954 15.1663 8.00065 15.1663Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00065 13.1663C5.15398 13.1663 2.83398 10.8463 2.83398 7.99967C2.83398 7.72634 3.06065 7.49967 3.33398 7.49967C3.60732 7.49967 3.83398 7.72634 3.83398 7.99967C3.83398 10.2997 5.70065 12.1663 8.00065 12.1663C10.3007 12.1663 12.1673 10.2997 12.1673 7.99967C12.1673 5.69967 10.3007 3.83301 8.00065 3.83301C7.72732 3.83301 7.50065 3.60634 7.50065 3.33301C7.50065 3.05967 7.72732 2.83301 8.00065 2.83301C10.8473 2.83301 13.1673 5.15301 13.1673 7.99967C13.1673 10.8463 10.8473 13.1663 8.00065 13.1663Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 11.1663C7.72667 11.1663 7.5 10.9397 7.5 10.6663C7.5 10.393 7.72667 10.1663 8 10.1663C9.19333 10.1663 10.1667 9.19301 10.1667 7.99967C10.1667 6.80634 9.19333 5.83301 8 5.83301C7.72667 5.83301 7.5 5.60634 7.5 5.33301C7.5 5.05967 7.72667 4.83301 8 4.83301C9.74667 4.83301 11.1667 6.25301 11.1667 7.99967C11.1667 9.74634 9.74667 11.1663 8 11.1663Z",
    fill: "#878787"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.0066fd45baf65e8ede6ca2874a3705fe.svg";
export { ForwardRef as ReactComponent };